import { useEffect, useState } from 'react';
import { BehaviorSubject } from 'rxjs';
import appConfigChannel from './sockets/appConfig';

export interface UseFeatureFlagsReturn {
  config: FeatureFlags;
  errorMessage: string | undefined;
}
export interface FeatureFlags {
  maintenance_mode: boolean;
  projects: boolean;
  thoughtspot_poc: boolean;
  support_entitlements: boolean;
  price_benchmarking?: boolean;
  ts_liveboard_id?: string;
  hex_embed: boolean;
  advise?: boolean;
  docs_viewer?: boolean;
  mcp_access_profiles?: boolean;
  reports_page?: boolean;
  projects_updates?: boolean;
  permission_sets?: boolean;
  block_list?: boolean;
  mentionable_upstackers?: boolean;
  related_inventory_reports?: boolean;
  orders_scheduled_reports?: boolean;
}
export const defaultFeatureFlags: FeatureFlags = {
  maintenance_mode: false,
  projects: false,
  thoughtspot_poc: false,
  support_entitlements: false,
  price_benchmarking: false,
  ts_liveboard_id: undefined,
  hex_embed: false,
  advise: false,
  docs_viewer: false,
  mcp_access_profiles: false,
  reports_page: false,
  projects_updates: false,
  permission_sets: false,
  block_list: false,
  mentionable_upstackers: false,
  related_inventory_reports: false,
  orders_scheduled_reports: false
};
const defaultErrorMessage = undefined;

const subject = new BehaviorSubject<FeatureFlags>(defaultFeatureFlags);
const errorSubject = new BehaviorSubject<string | undefined>(defaultErrorMessage);

export const getFeatureFlagErrorSubject = (): BehaviorSubject<string | undefined> => errorSubject;
export const getFeatureFlagSubject = (): BehaviorSubject<FeatureFlags> => subject;

export const useFeatureFlags = (): UseFeatureFlagsReturn => {
  const [config, setConfig] = useState<FeatureFlags>(defaultFeatureFlags);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(defaultErrorMessage);

  const connectedHandler = () => {};
  const disconnectedHandler = () => {};
  const receivedHandler = (data: FeatureFlags) => {
    setConfigData({ ...defaultFeatureFlags, ...data });
  };
  const createSocket = () => {
    appConfigChannel({ connectedHandler, disconnectedHandler, receivedHandler });
  };

  useEffect(() => {
    createSocket();

    const subscription = subject.subscribe((data) => {
      setConfig(data);
    });
    const errorSubscription = errorSubject.subscribe((message) => {
      setErrorMessage(message);
    });

    return () => {
      if (subscription) subscription.unsubscribe();
      if (errorSubscription) errorSubscription.unsubscribe();
    };
  }, []);

  const setConfigData = (configData: FeatureFlags) => subject.next(configData);

  return { config, errorMessage };
};
